import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { Home } from "react-feather";
import Select from "react-select";
import moment from "moment";
import axios from "axios";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import { KIBANA_PLM_URL, KIBANA_PLM_INTERNAL_URL } from "../../Common/KibanaAPIEndpoints/KibanaAPIEndpoints";

import { useKibanaAuthentication } from "../../hooks/useKibanaAuthentication";

export default function SystemWideResqueWorkers() {

  const {setToken} = useKibanaAuthentication();

  const [loading, setLoading] = useState(true)

  const search = useLocation().search;
  const commit = new URLSearchParams(search).get("commit");
  const tabNameFromSearchUrl = new URLSearchParams(search).get("filter[tab_name]");
  const tabNameFromUrl = window.location.hash.substr(1);
  const fromTimeFromUrl = new URLSearchParams(search).get("filter[time]");
  const searchParams = {
    geographicalCluster: new URLSearchParams(search).get("filter[geographical_cluster]"),
    jobType: new URLSearchParams(search).get("filter[job_type]"),
    clusterName: new URLSearchParams(search).get("filter[cluster_name]"),
    fromTime: fromTimeFromUrl == "now/d" ? "today" : fromTimeFromUrl,
    tabName: tabNameFromSearchUrl ? tabNameFromSearchUrl : tabNameFromUrl
  }
  const [geographicalCluster, setGeographicalCluster] = useState({ label: 'All', value: '*' });
  const [geographicalClusterOptions, setGeographicalClusterOptions] = useState([]);
  const [jobType, setJobType] = useState({ label: 'All', value: '*' });
  const [clusterName, setClusterName] = useState({ label: 'All', value: '*' });
  const [fromTime, setFromTime] = useState({ label: 'Today', value: 'today' });
  const [activeTab, setActiveTab] = useState(tabNameFromUrl ? tabNameFromUrl : 'recrawl');

  const jobTypeOptions = [
    { label: 'All', value: '*' },
    { label: 'Recrawl', value: 'recrawl' },
    { label: 'Distributed Recrawl', value: 'distributed_recrawl' },
    { label: 'Feedcrawl', value: 'feedcrawl3' },
    { label: 'Dependent Data Upload', value: 'dependent_data_upload' },
    { label: 'Total Workers', value: 'total_workers' },
  ]

  const clusterNameOptions = [
    { label: 'All', value: '*' },
    { label: 'cluster1', value: 'cluster1' },
    { label: 'cluster2', value: 'cluster2' },
  ]

  const timeOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Last 30 minutes', value: 'now-30m' },
    { label: 'Last 1 hour', value: 'now-1h' },
    { label: 'Last 2 hours', value: 'now-2h' },
    { label: 'Last 4 hours', value: 'now-4h' },
    { label: "Last 10 hours", value: "now-10h" },
    { label: 'Last 12 hours', value: 'now-12h' },
    { label: 'Last 24 hours', value: 'now-24h' },
    { label: 'Last 2 days', value: 'now-2d' },
    { label: 'Last 3 days', value: 'now-3d' },
    { label: 'Last 4 days', value: 'now-4d' },
    { label: 'Last 7 days', value: 'now-7d' },
    { label: 'Last 15 days', value: 'now-15d' },
    { label: 'Last 30 days', value: 'now-30d' },
    { label: 'Last 60 days', value: 'now-60d' },
    { label: 'Last 1 year', value: 'now-1y' }
  ];

  const [UrlParams, setUrlParams] = useState({
    geographicalCluster: "*",
    jobType: '*',
    clusterName: '*',
    fromTime: 'today',
    tabName: "recrawl"
  })

  useEffect(() => {
    setSearchParamsData();
    async function fetchInitialData() {
      try {
        setLoading(true);
        await setToken(KIBANA_PLM_URL)
        const res = await axios.get('/api/v1/internal/dropdown_list_helper')
        let geographical_clusters = []
        res.data.geographical_clusters.forEach(item => {
          geographical_clusters.push({ label: item, value: item })
        })
        geographical_clusters.push({ label: 'All', value: '*' })
        setGeographicalClusterOptions(geographical_clusters);

      } catch (err) {
        console.error("Failed to fetch data", err);
      } finally {
        setLoading(false);
      }
    }

    fetchInitialData();
  }, []);

  function setSearchParamsData() {
    if (searchParams.geographicalCluster && searchParams.geographicalCluster != geographicalCluster.value) {
      setGeographicalCluster({
        label: searchParams.geographicalCluster == '*' ? 'All' : searchParams.geographicalCluster,
        value: searchParams.geographicalCluster == "All" ? "*" : searchParams.geographicalCluster
      });
    }
    if (searchParams.jobType && searchParams.jobType != jobType.value) {
      setJobType(jobTypeOptions.filter(option => option.value == searchParams.jobType)[0]);
    }
    if (searchParams.clusterName && searchParams.clusterName != clusterName.value) {
      setClusterName(clusterNameOptions.filter(option => option.value == searchParams.clusterName)[0]);
    }
    if (searchParams.fromTime && searchParams.fromTime != fromTime.value) {
      setFromTime(timeOptions.filter(item => item.value == searchParams.fromTime)[0]);
    }
    if (searchParams.tabName && searchParams.tabName != activeTab) {
      setActiveTab(searchParams.tabName == "*"? "recrawl" : searchParams.tabName);
    }
    if (commit == 'Get Data' && searchParams.fromTime && searchParams.geographicalCluster && searchParams.jobType && searchParams.clusterName) {
      setUrlParams(searchParams)
    }
  }

  function recrawlKibanaUrl(kibana_url) {
    var from_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : UrlParams.fromTime;
    var to_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;
    var geographical_cluster_val = UrlParams.geographicalCluster == "All" ? "*" : UrlParams.geographicalCluster;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(pause:!t,value:0),time:(from:'${from_time_val}',to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:'custom:+%22resque_workers_tracker%22+AND+resque_worker_type:+%22recrawl%22+AND+cluster:${cluster_name_val}+AND+geographical_cluster:${geographical_cluster_val}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:total_workers),schema:metric,type:sum),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:auto,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:now%2Fd,to:now%2Fd),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(field:free_workers),schema:metric,type:sum),(enabled:!t,id:'4',params:(field:running_workers),schema:metric,type:sum)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),dimensions:(x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'HH:mm')),params:(bounds:(max:'2021-10-06T09:11:19.985Z',min:'2021-10-05T09:11:19.985Z'),date:!t,format:'HH:mm',interval:PT30M,intervalESUnit:m,intervalESValue:30)),y:!((accessor:1,aggType:sum,format:(id:number),params:()),(accessor:2,aggType:avg,format:(id:number),params:()),(accessor:3,aggType:avg,format:(id:number),params:()))),grid:(categoryLines:!f),labels:(),legendPosition:right,seriesParams:!((data:(id:'1',label:'Sum+of+total_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'3',label:'Sum+of+free_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'4',label:'Sum+of+running_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1)),thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:line,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:'Average+total_workers'),type:value))),title:'',type:line))`
  }

  function distributedRecrawlKibanaUrl(kibana_url) {
    var from_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : UrlParams.fromTime;
    var to_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;
    var geographical_cluster_val = UrlParams.geographicalCluster == "All" ? "*" : UrlParams.geographicalCluster;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(pause:!t,value:0),time:(from:'${from_time_val}',to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:'custom:+%22resque_workers_tracker%22+AND+resque_worker_type:+%22distributed_recrawl%22+AND+cluster:${cluster_name_val}+AND+geographical_cluster:${geographical_cluster_val}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:total_workers),schema:metric,type:sum),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:auto,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:now%2Fd,to:now%2Fd),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(field:free_workers),schema:metric,type:sum),(enabled:!t,id:'4',params:(field:running_workers),schema:metric,type:sum)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),dimensions:(x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'HH:mm')),params:(bounds:(max:'2021-10-06T09:11:19.985Z',min:'2021-10-05T09:11:19.985Z'),date:!t,format:'HH:mm',interval:PT30M,intervalESUnit:m,intervalESValue:30)),y:!((accessor:1,aggType:sum,format:(id:number),params:()),(accessor:2,aggType:avg,format:(id:number),params:()),(accessor:3,aggType:avg,format:(id:number),params:()))),grid:(categoryLines:!f),labels:(),legendPosition:right,seriesParams:!((data:(id:'1',label:'Sum+of+total_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'3',label:'Sum+of+free_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'4',label:'Sum+of+running_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1)),thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:line,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:'Average+total_workers'),type:value))),title:'',type:line))`
  }

  function feedcrawlKibanaUrl(kibana_url) {
    var from_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : UrlParams.fromTime;
    var to_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;
    var geographical_cluster_val = UrlParams.geographicalCluster == "All" ? "*" : UrlParams.geographicalCluster;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(pause:!t,value:0),time:(from:'${from_time_val}',to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:'custom:+%22resque_workers_tracker%22+AND+resque_worker_type:+%22feedcrawl3%22+AND+cluster:${cluster_name_val}+AND+geographical_cluster:${geographical_cluster_val}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:total_workers),schema:metric,type:sum),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:auto,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:now%2Fd,to:now%2Fd),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(field:free_workers),schema:metric,type:sum),(enabled:!t,id:'4',params:(field:running_workers),schema:metric,type:sum)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),dimensions:(x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'HH:mm')),params:(bounds:(max:'2021-10-06T09:11:19.985Z',min:'2021-10-05T09:11:19.985Z'),date:!t,format:'HH:mm',interval:PT30M,intervalESUnit:m,intervalESValue:30)),y:!((accessor:1,aggType:sum,format:(id:number),params:()),(accessor:2,aggType:avg,format:(id:number),params:()),(accessor:3,aggType:avg,format:(id:number),params:()))),grid:(categoryLines:!f),labels:(),legendPosition:right,seriesParams:!((data:(id:'1',label:'Sum+of+total_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'3',label:'Sum+of+free_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'4',label:'Sum+of+running_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1)),thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:line,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:'Average+total_workers'),type:value))),title:'',type:line))`
  }

  function dependentDataUploadKibanaUrl(kibana_url) {
    var from_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : UrlParams.fromTime;
    var to_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;
    var geographical_cluster_val = UrlParams.geographicalCluster == "All" ? "*" : UrlParams.geographicalCluster;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(pause:!t,value:0),time:(from:'${from_time_val}',to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:'custom:+%22resque_workers_tracker%22+AND+resque_worker_type:+%22dependent_data_upload%22+AND+cluster:${cluster_name_val}+AND+geographical_cluster:${geographical_cluster_val}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:total_workers),schema:metric,type:sum),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:auto,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:now%2Fd,to:now%2Fd),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(field:free_workers),schema:metric,type:sum),(enabled:!t,id:'4',params:(field:running_workers),schema:metric,type:sum)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),dimensions:(x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'HH:mm')),params:(bounds:(max:'2021-10-06T09:11:19.985Z',min:'2021-10-05T09:11:19.985Z'),date:!t,format:'HH:mm',interval:PT30M,intervalESUnit:m,intervalESValue:30)),y:!((accessor:1,aggType:sum,format:(id:number),params:()),(accessor:2,aggType:avg,format:(id:number),params:()),(accessor:3,aggType:avg,format:(id:number),params:()))),grid:(categoryLines:!f),labels:(),legendPosition:right,seriesParams:!((data:(id:'1',label:'Sum+of+total_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'3',label:'Sum+of+free_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'4',label:'Sum+of+running_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1)),thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:line,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:'Average+total_workers'),type:value))),title:'',type:line))`
  }

  function totalWorkersKibanaUrl(kibana_url) {
    var from_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : UrlParams.fromTime;
    var to_time_val = UrlParams.fromTime == "today" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;
    var geographical_cluster_val = UrlParams.geographicalCluster == "All" ? "*" : UrlParams.geographicalCluster;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(pause:!t,value:0),time:(from:'${from_time_val}',to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:'custom:+%22resque_workers_tracker%22+AND+resque_worker_type:%20all_resque_workers%20+AND+cluster:${cluster_name_val}+AND+geographical_cluster:${geographical_cluster_val}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(field:total_workers),schema:metric,type:sum),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:auto,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:now%2Fd,to:now%2Fd),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(field:free_workers),schema:metric,type:sum),(enabled:!t,id:'4',params:(field:running_workers),schema:metric,type:sum)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),dimensions:(x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'HH:mm')),params:(bounds:(max:'2021-10-06T09:11:19.985Z',min:'2021-10-05T09:11:19.985Z'),date:!t,format:'HH:mm',interval:PT30M,intervalESUnit:m,intervalESValue:30)),y:!((accessor:1,aggType:sum,format:(id:number),params:()),(accessor:2,aggType:avg,format:(id:number),params:()),(accessor:3,aggType:avg,format:(id:number),params:()))),grid:(categoryLines:!f),labels:(),legendPosition:right,seriesParams:!((data:(id:'1',label:'Sum+of+total_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'3',label:'Sum+of+free_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1),(data:(id:'4',label:'Sum+of+running_workers'),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1)),thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:line,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:'Average+total_workers'),type:value))),title:'',type:line))`
  }

  const handleGetData = () => {
    window.location.href = `/internal/resque_info/system_wide_resque_workers?filter[geographical_cluster]=${geographicalCluster.value}&filter[job_type]=${jobType.value}&filter[cluster_name]=${clusterName.value}&filter[time]=${fromTime.value}&filter[tab_name]=${jobType.value == 'feedcrawl3' ? 'feedcrawl' : jobType.value}&commit=${'Get Data'}`
  }

  if(loading) {
    return (
      <Loader type="Puff" color="#00BFFF" height={100} width={100} className='pc-loader' />
    )
  }

  return <Container fluid>
    <div className="page-title">
      <Row className=''>
        <Col xs="6">
          <h3>Internal Dashboard</h3>
        </Col>
        <Col xs="6">
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to={'/internal'}>
                <Home />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              {commit == 'Get Data' ? <a href="/internal/resque_info/system_wide_resque_workers">System Wide Resque Workers</a> : 'System Wide Resque Workers'}
            </BreadcrumbItem>
            {commit == 'Get Data' && <BreadcrumbItem className="fw-bold">
              Search
            </BreadcrumbItem>}
          </Breadcrumb>
        </Col>
      </Row>
    </div>

    <Card>
      <CardBody>
        <Row>
          <Col sm="3">
            <label className="fw-bold">Geographical Cluster</label>
            <Select
              value={geographicalCluster}
              options={geographicalClusterOptions}
              onChange={option => setGeographicalCluster(option)} />
          </Col>
          <Col sm="3">
            <label className="fw-bold">Time</label>
            <Select
              value={fromTime}
              options={timeOptions}
              onChange={option => setFromTime(option)} />
          </Col>
          <Col sm="3">
            <label className="fw-bold">Job Type</label>
            <Select
              value={jobType}
              options={jobTypeOptions}
              onChange={option => setJobType(option)} />
          </Col>
          <Col sm="3">
            <label className="fw-bold">Choose Cluster</label>
            <Select
              value={clusterName}
              options={clusterNameOptions}
              onChange={option => setClusterName(option)} />
          </Col>
        </Row>
        <Row className="align-items-end mt-4">
          <Col sm="4">
            <button className="btn btn-success w-100" onClick={handleGetData}>Get Data</button>
          </Col>
        </Row>
      </CardBody>
    </Card>
    <Card>
      <CardBody>
        <div className="mb-1">
          <b>NOTE:</b>
          If the graph is not shown after your form submission then you should do either maximize its size(the option is available on the right side of graph) or minimize the sidebar.
        </div>
        <Nav tabs>
          <NavItem>
            <NavLink className={activeTab == 'recrawl' ? 'active' : ''} onClick={() => setActiveTab('recrawl')}>
              Recrawl
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'distributed_recrawl' ? 'active' : ''} onClick={() => setActiveTab('distributed_recrawl')}>
              Distributed Recrawl
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'feedcrawl' ? 'active' : ''} onClick={() => setActiveTab('feedcrawl')}>
              Feedcrawl
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'dependent_data_upload' ? 'active' : ''} onClick={() => setActiveTab('dependent_data_upload')}>
              Dependent Data Upload
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'total_workers' ? 'active' : ''} onClick={() => setActiveTab('total_workers')}>
              Total Workers
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={'recrawl'}>
            {(UrlParams.jobType == 'recrawl' || UrlParams.jobType == '*' ) ? <div className="panel-body">
              <center>
                <span className="fw-bold">Recrawl</span><br />
                <a target="_blank" className="link-primary" href={recrawlKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={recrawlKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>
            }
          </TabPane>
          <TabPane tabId={'distributed_recrawl'}>
            {(UrlParams.jobType == 'distributed_recrawl' || UrlParams.jobType == '*') ? <div className="panel-body">
              <center>
                <span className="fw-bold">Distributed Recrawl</span><br />
                <a target="_blank" className="link-primary" href={distributedRecrawlKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={distributedRecrawlKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="800" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>
            }
          </TabPane>
          <TabPane tabId={'feedcrawl'}>
            {(UrlParams.jobType == 'feedcrawl'  || UrlParams.jobType == '*') ? <div className="panel-body">
              <center>
                <span className="fw-bold">Feedcrawl</span><br />
                <a target="_blank" className="link-primary" href={feedcrawlKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={feedcrawlKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>
            }
          </TabPane>
          <TabPane tabId={'dependent_data_upload'}>
            {(UrlParams.jobType == 'dependent_data_upload' || UrlParams.jobType == '*') ? <div className="panel-body">
              <center>
                <span className="fw-bold">Dependent Data Upload</span><br />
                <a target="_blank" className="link-primary" href={dependentDataUploadKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={dependentDataUploadKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>
            }
          </TabPane>
          <TabPane tabId={'total_workers'}>
            {(UrlParams.jobType == 'total_workers' || UrlParams.jobType == '*') ? <div className="panel-body">
              <center>
                <span className="fw-bold">Total Workers</span><br />
                <a target="_blank" className="link-primary" href={totalWorkersKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={totalWorkersKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>}
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  </Container>
}

